'use client'

import { type ComponentProps } from 'react'

import { useController } from 'react-hook-form'

import { useFormField } from '@/shared/ui/form'
import { Textarea as UITextarea } from '@/shared/ui/textarea'

type TextareaProps = Omit<ComponentProps<'textarea'>, 'defaultValue'>

export function Textarea({ disabled, onChange, ...props }: TextareaProps) {
  const { name } = useFormField()
  const {
    field,
    fieldState: { error }
  } = useController({ name, disabled })

  return (
    <UITextarea
      {...props}
      {...field}
      value={field.value ?? ''}
      disabled={disabled}
      onChange={e => {
        field.onChange(e)
        onChange?.(e)
      }}
      aria-invalid={!!error}
    />
  )
}
